import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { BadgesProvider } from "@/context/BadgesContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import MediaDetail from "@/pages/MediaDetail";
import Provinces from "@/pages/Provinces";
import ProvinceDetail from "@/pages/ProvinceDetail";
import Rankings from "@/pages/Rankings";
import Favorites from "@/pages/Favorites";
import SharedFavorites from "@/pages/SharedFavorites";
import Profile from "@/pages/Profile";
import RegisterMedia from "@/pages/RegisterMedia";
import Login from "@/pages/auth/Login";
import ManagerLogin from "@/pages/auth/ManagerLogin";
import AdminLogin from "@/pages/auth/AdminLogin";
import Register from "@/pages/auth/Register";
import { ForgotPassword, ResetPassword } from "@/pages/auth/PasswordFlows";
import AuthCallback from "@/pages/auth/AuthCallback";
import ManagerDashboard from "@/pages/ManagerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import VerifyCertificate from "@/pages/VerifyCertificate";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import "@/App.css";

function AppRoutes() {
  const location = useLocation();
  // Handle Emergent Google Auth callback synchronously (before route resolution)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/manager/login" element={<ManagerLogin />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/browse" element={<Browse />} />
        <Route path="/tv/:slug" element={<MediaDetail />} />
        <Route path="/radio/:slug" element={<MediaDetail />} />
        <Route path="/provinces" element={<Provinces />} />
        <Route path="/province/:slug" element={<ProvinceDetail />} />
        <Route path="/rankings" element={<Rankings />} />
        <Route path="/favorites" element={<Favorites />} />
        <Route path="/f/:token" element={<SharedFavorites />} />
        <Route path="/verify/:id" element={<VerifyCertificate />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/register-media" element={<RegisterMedia />} />
        <Route path="/manager" element={<ProtectedRoute><ManagerDashboard /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <PlayerProvider>
            <BadgesProvider>
              <AppRoutes />
              <Toaster position="top-center" richColors />
            </BadgesProvider>
          </PlayerProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
